import { render } from "./TransfoPackageInput.vue?vue&type=template&id=5eb965a7&ts=true"
import script from "./TransfoPackageInput.vue?vue&type=script&lang=ts"
export * from "./TransfoPackageInput.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__